import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { AuthProvider } from './contexts/userAuthentication';
import { AppRoutes } from './routes/App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Router>
        <AuthProvider> 
            <AppRoutes />
        </AuthProvider>
    </Router>
);